import {DishDocker} from "aaden-base-model/lib";

export const Cart = DishDocker.StandardDishesListFactory()
